import { AxiosInstance } from "axios";

/**
 * Initiate client core model for axios interceptor
 */
export default abstract class ClientCoreModel {
    protected axios: AxiosInstance;
    protected context: any;
    constructor(axios: AxiosInstance, context: any) {
        this.axios = axios;
        this.context = context;
    }
}